export const CHANGE_COLLECTIONS_VERSION = 'CHANGE_COLLECTIONS_VERSION';
